<div class="dropdown-box">
   <p (click)="handleOptionClicked(option)" *ngFor="let option of options">{{option.label}}</p>
</div>
